import 'babel-polyfill';
import React from 'react';
import { connect } from 'react-redux';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import routes from './route';
import { ready, getAppInfo } from '../../lib/kbApp/kbJsBridgePromise';
import { getAppMainAccount, checkLogin } from '@/lib/services/kbAppService';
import Aegis from '@tencent/aegis-web-sdk';
import store from '../../store';
import { setNightMode } from '@/actions/index';
import { detector } from '../../lib/util/Detect';

const routeMap = () => (
	<Switch>
		{routes.map(({ path, exact, component }) => (
			<Route
				exact={exact}
				path={path}
				key={path}
				component={component}
			></Route>
		))}
	</Switch>
);

const defaultOpts = {
  id: 6848,
  reportApiSpeed: true,
  reportAssetSpeed: true,
  offlineLog: true,
  spa: true,
};

const App = ({ mapAppInfo }) => {
  ready().then(() => {
    // 判断是否夜间模式
    getNightmodeEnabled();
    getAppInfo().then((res) => {
      mapAppInfo(res);
    });
    checkLogin().then((res) => {
      if (res) {
        getAppMainAccount().then((data) => {
          const { userId } = data.userInfo || {};
          const opts = {
            ...defaultOpts,
            uin: userId,
          };
          window.aegisIns = new Aegis(opts);
        });
      } else {
        window.aegisIns = new Aegis(defaultOpts);
      }
    });
  });

  return (
		<Router>
			<Route render={routeMap}></Route>
		</Router>
  );
};

const getNightmodeEnabled = () => {
  if (window.browser && window.browser && window.browser.screen.getNightmodeEnabled) {
    window.browser.screen.getNightmodeEnabled((nightMode) => {
      // 这里有个坑，ios返回的居然是字符串‘false’和‘true’，所以这里需要处理一下
      store.dispatch(setNightMode(detector.os.ios ? nightMode === 'true' : nightMode));
    });
  }
};

const mapDispatchToProps = dispatch => ({
  mapAppInfo(data) {
    dispatch({
      type: 'map_app_info',
      data,
    });
  },
  getNightmodeEnabled,
});


export default connect(
  null,
  mapDispatchToProps
)(App);
